module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newRunPoint"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("跑步点位管理 >\n        "), (_vm.edit === false) ? _c('span', [_vm._v("新增点位广告")]) : _vm._e(), _vm._v(" "), (_vm.edit !== false) ? _c('span', [_vm._v("编辑点位广告")]) : _vm._e(), _vm._v(" "), _c('span', [_c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "~click": function($event) {
        return _vm.add(0)
      }
    }
  }, [_vm._v("保存草稿")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "~click": function($event) {
        return _vm.add(1)
      }
    }
  }, [_vm._v("发布")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('el-form', {
    ref: "runPointForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.runPointForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "广告说明：",
      "prop": "description",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "runPointTitle",
    attrs: {
      "placeholder": "广告说明"
    },
    model: {
      value: (_vm.runPointForm.description),
      callback: function($$v) {
        _vm.$set(_vm.runPointForm, "description", $$v)
      },
      expression: "runPointForm.description"
    }
  })], 1), _vm._v(" "), _c('select-school', {
    attrs: {
      "schObj": _vm.runPointForm.schObj
    },
    on: {
      "changeVal": _vm.getVal
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开始时间：",
      "required": ""
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择开始日期"
    },
    model: {
      value: (_vm.runPointForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.runPointForm, "startTime", $$v)
      },
      expression: "runPointForm.startTime"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "选择开始时间"
    },
    model: {
      value: (_vm.runPointForm.startTimeHour),
      callback: function($$v) {
        _vm.$set(_vm.runPointForm, "startTimeHour", $$v)
      },
      expression: "runPointForm.startTimeHour"
    }
  }, _vm._l((_vm.dateHours), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结束时间：",
      "required": ""
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择结束日期"
    },
    model: {
      value: (_vm.runPointForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.runPointForm, "endTime", $$v)
      },
      expression: "runPointForm.endTime"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "选择结束时间"
    },
    model: {
      value: (_vm.runPointForm.endTimeHour),
      callback: function($$v) {
        _vm.$set(_vm.runPointForm, "endTimeHour", $$v)
      },
      expression: "runPointForm.endTimeHour"
    }
  }, _vm._l((_vm.dateHours), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "prizeContent",
    attrs: {
      "label": "广告曝光代码:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5
      },
      "placeholder": "广告曝光代码"
    },
    model: {
      value: (_vm.runPointForm.adExposingCodes),
      callback: function($$v) {
        _vm.$set(_vm.runPointForm, "adExposingCodes", $$v)
      },
      expression: "runPointForm.adExposingCodes"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跑步点位图标：",
      "prop": "fid"
    }
  }, [_c('div', {
    staticStyle: {
      "min-width": "500px"
    }
  }, [_c('el-upload', {
    staticClass: "mybtn",
    attrs: {
      "action": _vm.fileActionUrl,
      "on-success": _vm.handleSuccess,
      "on-error": _vm.handleError,
      "name": "file",
      "headers": _vm.headers,
      "show-file-list": false
    }
  }, [(!_vm.runPointForm.fid) ? _c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_c('span', [_vm._v("选择图片压缩包")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("（格式：.zip）")])]) : _vm._e(), _vm._v(" "), (_vm.runPointForm.fid) ? _c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_c('span', [_vm._v("重新上传压缩包")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("（格式：.zip）")])]) : _vm._e(), _vm._v(" "), (_vm.runPointForm.fid) ? _c('span', [_vm._v(" 已上传")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "el-loadbox"
  }, [_c('p', [_vm._v("需要放入2x和3x图 图片实际命名示例：")]), _vm._v(" "), _c('p', [_vm._v("未经过普通点位：")]), _vm._v(" "), _c('p', [_vm._v("img_point_normal@2x.png")]), _vm._v(" "), _c('p', [_vm._v("img_point_normal@3x.png")])])], 1), _vm._v(" "), _c('p', [_vm._v("点位命名规则：")]), _vm._v(" "), _c('p', {
    staticClass: "gray"
  }, [_vm._v("未经过普通点位：img_point_normal.png")]), _vm._v(" "), _c('p', {
    staticClass: "gray"
  }, [_vm._v("经过的普通点位：img_point_normal_pass.png")]), _vm._v(" "), _c('p', {
    staticClass: "gray"
  }, [_vm._v("未经过指定点位：img_point_must_normal.png")]), _vm._v(" "), _c('p', {
    staticClass: "gray"
  }, [_vm._v("经过的指定点位：img_point_must_pass.png")]), _vm._v(" "), _c('p', {
    staticClass: "gray"
  }, [_vm._v("起点：img_point_start.png")]), _vm._v(" "), _c('p', {
    staticClass: "gray"
  }, [_vm._v("终点：img_point_end.png")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "gray"
  }, [_vm._v("未解锁的第一个点位：run_point_first_lock.png")]), _vm._v(" "), _c('p', {
    staticClass: "gray"
  }, [_vm._v("未解锁的第二个点位：run_point_second_lock.png")]), _vm._v(" "), _c('p', {
    staticClass: "gray"
  }, [_vm._v("未解锁的第三个点位：run_point_third_lock.png")]), _vm._v(" "), _c('p', {
    staticClass: "gray"
  }, [_vm._v("未解锁的第四个点位：run_point_fourth_lock.png")]), _vm._v(" "), _c('p', {
    staticClass: "gray"
  }, [_vm._v("未解锁的第五个点位：run_point_fifth_lock.png")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "gray"
  }, [_vm._v("已解锁的第一个点位：run_point_first.png")]), _vm._v(" "), _c('p', {
    staticClass: "gray"
  }, [_vm._v("已解锁的第二个点位：run_point_second.png")]), _vm._v(" "), _c('p', {
    staticClass: "gray"
  }, [_vm._v("已解锁的第三个点位：run_point_third.png")]), _vm._v(" "), _c('p', {
    staticClass: "gray"
  }, [_vm._v("已解锁的第四个点位：run_point_fourth.png")]), _vm._v(" "), _c('p', {
    staticClass: "gray"
  }, [_vm._v("已解锁的第五个点位：run_point_fifth.png")])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62cb5ce6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/runPoint/newRunPoint.vue
// module id = 1048
// module chunks = 0